<div>
  @switch (elementType) {
    @case ('batteryIcon') {
      @if (value) {
        <i class="fa-solid fa-fw fa-lg" [ngClass]="value | batteryIcon"></i>
      }
      @if (!value) {
        <span>{{ "NONE" | translate }}</span>
      }
    }
    @case ('deviceStatus') {
      @if (value) {
        <app-feature-badge
        [feature]="value | deviceStatusSelector"></app-feature-badge>
      }
      @if (!value) {
        <span>{{ "NONE" | translate }}</span>
      }
    }
    @default {
      <span>{{ value || ("NONE" | translate) }}</span>
    }
  }
</div>